/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetToolUsageSummaryPayload,
  GetToolUsageSummaryPayload$Outbound,
  GetToolUsageSummaryPayload$outboundSchema,
} from "../components/gettoolusagesummarypayload.js";

export type GetToolUsageUserTimeSeriesSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetToolUsageUserTimeSeriesSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetToolUsageUserTimeSeriesSecurity = {
  option1?: GetToolUsageUserTimeSeriesSecurityOption1 | undefined;
  option2?: GetToolUsageUserTimeSeriesSecurityOption2 | undefined;
};

export type GetToolUsageUserTimeSeriesRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getToolUsageSummaryPayload: GetToolUsageSummaryPayload;
};

/** @internal */
export type GetToolUsageUserTimeSeriesSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetToolUsageUserTimeSeriesSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetToolUsageUserTimeSeriesSecurityOption1$Outbound,
    GetToolUsageUserTimeSeriesSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getToolUsageUserTimeSeriesSecurityOption1ToJSON(
  getToolUsageUserTimeSeriesSecurityOption1:
    GetToolUsageUserTimeSeriesSecurityOption1,
): string {
  return JSON.stringify(
    GetToolUsageUserTimeSeriesSecurityOption1$outboundSchema.parse(
      getToolUsageUserTimeSeriesSecurityOption1,
    ),
  );
}

/** @internal */
export type GetToolUsageUserTimeSeriesSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetToolUsageUserTimeSeriesSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetToolUsageUserTimeSeriesSecurityOption2$Outbound,
    GetToolUsageUserTimeSeriesSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getToolUsageUserTimeSeriesSecurityOption2ToJSON(
  getToolUsageUserTimeSeriesSecurityOption2:
    GetToolUsageUserTimeSeriesSecurityOption2,
): string {
  return JSON.stringify(
    GetToolUsageUserTimeSeriesSecurityOption2$outboundSchema.parse(
      getToolUsageUserTimeSeriesSecurityOption2,
    ),
  );
}

/** @internal */
export type GetToolUsageUserTimeSeriesSecurity$Outbound = {
  Option1?: GetToolUsageUserTimeSeriesSecurityOption1$Outbound | undefined;
  Option2?: GetToolUsageUserTimeSeriesSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetToolUsageUserTimeSeriesSecurity$outboundSchema: z.ZodMiniType<
  GetToolUsageUserTimeSeriesSecurity$Outbound,
  GetToolUsageUserTimeSeriesSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetToolUsageUserTimeSeriesSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetToolUsageUserTimeSeriesSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getToolUsageUserTimeSeriesSecurityToJSON(
  getToolUsageUserTimeSeriesSecurity: GetToolUsageUserTimeSeriesSecurity,
): string {
  return JSON.stringify(
    GetToolUsageUserTimeSeriesSecurity$outboundSchema.parse(
      getToolUsageUserTimeSeriesSecurity,
    ),
  );
}

/** @internal */
export type GetToolUsageUserTimeSeriesRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetToolUsageSummaryPayload: GetToolUsageSummaryPayload$Outbound;
};

/** @internal */
export const GetToolUsageUserTimeSeriesRequest$outboundSchema: z.ZodMiniType<
  GetToolUsageUserTimeSeriesRequest$Outbound,
  GetToolUsageUserTimeSeriesRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getToolUsageSummaryPayload: GetToolUsageSummaryPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getToolUsageSummaryPayload: "GetToolUsageSummaryPayload",
    });
  }),
);

export function getToolUsageUserTimeSeriesRequestToJSON(
  getToolUsageUserTimeSeriesRequest: GetToolUsageUserTimeSeriesRequest,
): string {
  return JSON.stringify(
    GetToolUsageUserTimeSeriesRequest$outboundSchema.parse(
      getToolUsageUserTimeSeriesRequest,
    ),
  );
}
